import React from 'react';

const Homes = () => {
  return (
    <section className="home">
      {/* <Header/> */}
      <h1>Welcome to Health Couch</h1>
      <p>Your trusted partner in healthcare solutions.</p>
    </section>
  );
};

export default Homes;
